import { CircularProgress } from '@mui/material'
import React, { useState } from 'react'
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import { useTranslate } from 'react-admin';

export const CheckItemsModal = ({items}) => {
    const translate = useTranslate()


  return (
    <div>
        <div style={{display:'flex', flexDirection:'row', justifyContent:'space-evenly', marginBottom:'15px'}}>
          <div style={{width:'60%', fontWeight:'bold'}}>
            {translate('ra.field.item_descripcion')}
          </div>
          <div style={{width:'40%', fontWeight:'bold'}}>
            {translate('ra.field.invoice')}
          </div>
        </div>
        {
            items.map((item, i)=>(
              <div>
                <div style={{display:'flex', flexDirection:'row', justifyContent:'space-evenly'}}>
                  <div style={{width:'60%'}}>
                    <label style={{fontWeight:'bold', alignItems:'center'}}>
                      {`${item.name}  ${item.code}  ${item.number}`}
                    </label>
                  </div>
                  <div style={{display:'flex', flexDirection:'column', alignItems:'flex-start', width:'40%'}}>
                    {
                      item.bills ? 
                      item.bills.map(billInfo=>(
                        <label>
                          {`${billInfo.document_type} ${billInfo.document_number}`}
                        </label>
                      )) :
                      <CheckCircleOutlineIcon color='success'/>
                    }
                  </div>
                </div>
                <hr />
              </div>
            ))
        }
    </div>
  )
}

